import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EditCharterComponent } from './edit.component';
import { EditCharterResolve } from './edit.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'edit',
        component: EditCharterComponent,
        resolve: {
          portal: EditCharterResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class EditCharterRoutingModule {}
